import { Helmet } from "react-helmet-async"
import { CancellationPoliciesList } from "../../../../CancellationPolicy"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"

export default function OrganizationCancellationPoliciesPage() {
	return (
		<>
			<Helmet>
				<title>Cancellation Policies | Org</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<CancellationPoliciesList />
			</ForbidUnlessAuthorized>
		</>
	)
}
